import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-p2-export-procs',
  templateUrl: './p2-export-procs.component.html',
  styleUrls: ['./p2-export-procs.component.css']
})
export class P2ExportProcsComponent implements OnInit {
    public itemsListExportProcedures: Item[] = [];

    constructor(private datatask: DataTaskService) {

    }

    private async loadExportProcedures() {
        this.itemsListExportProcedures = await this.datatask.Post(891);
    }

    private async init() {
        this.loadExportProcedures();
    }

    ngOnInit() {
        this.init();
    }
}
